/* Teeez: native swipe for homepage product rows, with the line indicator in sync */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const done = new WeakSet();

  function setup(root, opts) {
    opts = opts || {};
    const viewport = root.querySelector('.carousel--x-container');
    /* Kept in memory, not as an attribute: the variant image app clones the gallery,
       and a copied attribute would make the clone look set up while it has no listeners */
    if (!viewport || done.has(viewport)) return;
    done.add(viewport);

    const dots = () => Array.from(root.querySelectorAll('.carousel--dot'));

    /* Rows that fit in one theme slide (like Bundles) get no dots from the theme.
       Give them one line segment per product so the indicator still follows the swipe. */
    const ensureDots = () => {
      const nav = root.querySelector('.carousel--dot-nav');
      if (!nav || dots().length) return;
      const count = root.querySelectorAll('.carousel--block').length;
      if (count < 2 || viewport.scrollWidth <= viewport.clientWidth + 2) return;
      for (let n = 0; n < count; n++) {
        const d = document.createElement('div');
        d.className = 'carousel--dot';
        d.setAttribute('data-active', n === 0 ? 'true' : 'false');
        nav.appendChild(d);
      }
    };
    const max = () => Math.max(1, viewport.scrollWidth - viewport.clientWidth);

    const sync = () => {
      /* Keep the theme arrows in step with the scroll position */
      root.setAttribute('data-at-start', viewport.scrollLeft <= 2 ? 'true' : 'false');
      root.setAttribute('data-at-end', viewport.scrollLeft >= max() - 2 ? 'true' : 'false');
      ensureDots();
      const list = dots();
      if (!list.length) return;
      const i = Math.round((viewport.scrollLeft / max()) * (list.length - 1));
      list.forEach((d, n) => d.setAttribute('data-active', n === i ? 'true' : 'false'));
    };

    let raf = null;
    viewport.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => { raf = null; sync(); });
    }, { passive: true });

    const go = (left) => viewport.scrollTo({ left, behavior: reduceMotion.matches ? 'auto' : 'smooth' });

    /* Take over dot and arrow clicks before the theme slider handles them */
    root.addEventListener('click', (e) => {
      const dot = e.target.closest('.carousel--dot');
      const next = e.target.closest('.carousel--next');
      const prev = e.target.closest('.carousel--prev');
      if (!dot && !next && !prev) return;
      e.stopPropagation();
      e.preventDefault();
      if (dot) {
        const list = dots();
        const i = list.indexOf(dot);
        go(list.length > 1 ? (i / (list.length - 1)) * max() : 0);
      } else {
        const block = root.querySelector('.carousel--block');
        const step = block ? block.getBoundingClientRect().width : viewport.clientWidth * 0.8;
        go(viewport.scrollLeft + (next ? 1 : -1) * step);
      }
    }, true);

    /* The theme listens for its own swipe events; stop it from moving the row */
    viewport.addEventListener('touchstart', () => { root.swipe_state = null; }, { passive: true });

    root._teeezSync = sync;
    setTimeout(sync, 300);
    window.addEventListener('resize', sync, { passive: true });
    if (opts.bubble === false) return;

    /* Rhode style swipe bubble on mobile, gone after the first swipe */
    const lang = (document.documentElement.lang || 'en').slice(0, 2);
    const bubble = document.createElement('span');
    bubble.className = 'teeez-swipe-bubble';
    bubble.setAttribute('aria-hidden', 'true');
    bubble.textContent = lang === 'es' ? 'desliza' : 'swipe';
    root.style.position = root.style.position || 'relative';
    root.appendChild(bubble);
    const hideBubble = () => { if (viewport.scrollLeft > 8) bubble.classList.add('is-hidden'); };
    viewport.addEventListener('scroll', hideBubble, { passive: true });
  }

  const init = () => {
    document.querySelectorAll('carousel-root').forEach((root) => {
      if (root.closest('.product-page--carousel')) setup(root, { bubble: false });
      else if (root.closest('.template--index') && root.querySelector('.product--root')) setup(root);
    });
  };

  /* Product page: the variant image app rebuilds the gallery when a colour is picked.
     Hook up the new gallery and start again at the first image. */
  const watchProductGallery = () => {
    const holder = document.querySelector('.product-page--carousel');
    if (!holder || holder.dataset.teeezWatch) return;
    holder.dataset.teeezWatch = 'true';
    let t = null;

    /* Open on the first photo. The theme and the variant image app sometimes leave the
       gallery on the 3rd or 4th photo after loading. Until the shopper swipes, keep it at the start. */
    let swiped = false;
    ['touchstart', 'pointerdown', 'wheel'].forEach((ev) => holder.addEventListener(ev, () => { swiped = true; }, { passive: true }));
    const toStart = () => {
      if (swiped) return;
      holder.querySelectorAll('.carousel--x-container').forEach((vp) => { if (vp.scrollLeft) vp.scrollLeft = 0; });
      holder.querySelectorAll('carousel-root').forEach((root) => { if (root._teeezSync) root._teeezSync(); });
    };
    [0, 300, 800, 1500, 2500, 4000].forEach((ms) => setTimeout(toStart, ms));
    window.addEventListener('load', () => { toStart(); setTimeout(toStart, 500); });
    /* A colour choice is a deliberate change: show that colour's photo first again */
    document.addEventListener('change', (e) => {
      if (e.target && e.target.closest && e.target.closest('.product-page--root, product-options-root, .swatches')) swiped = false;
    }, true);
    new MutationObserver(() => {
      clearTimeout(t);
      t = setTimeout(() => {
        init();
        holder.querySelectorAll('carousel-root').forEach((root) => {
          const vp = root.querySelector('.carousel--x-container');
          const sig = Array.from(root.querySelectorAll('.carousel--block img'))
            .map((img) => img.getAttribute('data-srcset') || img.getAttribute('data-src') || img.getAttribute('src') || '')
            .join('|').slice(0, 4000);
          if (vp && ((root._teeezSig !== undefined && root._teeezSig !== sig) || !swiped)) vp.scrollLeft = 0;
          root._teeezSig = sig;
          if (root._teeezSync) root._teeezSync();
        });
      }, 120);
    }).observe(holder, { childList: true, subtree: true });
  };

  const start = () => { init(); watchProductGallery(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  window.addEventListener('load', start);
  document.addEventListener('shopify:section:load', init);
})();

/* Teeez 3.52: bundles with more than 250 colour combinations.
   The theme only knows the first 250 variants. For larger products the chosen combination
   is fetched from Shopify, so every combination can be selected and added to the bag. */
(() => {
  if (!window.customElements) return;
  customElements.whenDefined('product-options-root').then(() => {
    const C = customElements.get('product-options-root');
    if (!C || C.prototype._teeezBig) return;
    C.prototype._teeezBig = true;
    const big = (el) => el.variants && Number(el.dataset.teeezTotal || 0) > el.variants.length;
    const clear = (el) => {
      if (!el.options_container) return;
      el.options_container.querySelectorAll('.radios--input').forEach((x) => { x.removeAttribute('data-unavailable'); x.removeAttribute('data-empty'); });
    };
    const origDisabled = C.prototype.updateDisabledOptions;
    C.prototype.updateDisabledOptions = function (a, b) { if (big(this)) return clear(this); return origDisabled.call(this, a, b); };
    const origEmpty = C.prototype.disableEmptyOptions;
    C.prototype.disableEmptyOptions = function () { if (big(this)) return clear(this); return origEmpty.call(this); };
    const origUpdate = C.prototype.updateVariant;
    C.prototype.updateVariant = function (v, target) {
      if (v || !big(this)) return origUpdate.call(this, v, target);
      const checked = Array.from(this.options_container.querySelectorAll('[data-item="radio"]:checked'));
      const ids = checked.map((i) => i.dataset.ovId).join(',');
      const values = checked.map((i) => i.value);
      this._teeezCache = this._teeezCache || {};
      const finish = (found) => {
        /* The add to bag field only lists the first 250 variants: add the found one */
        if (found && found.id) {
          const scope = this.root || document;
          scope.querySelectorAll('select[name="id"]').forEach((sel) => {
            if (!sel.querySelector('option[value="' + found.id + '"]')) {
              const o = document.createElement('option');
              o.value = found.id;
              o.textContent = found.title || '';
              sel.appendChild(o);
            }
          });
        }
        return origUpdate.call(this, found || false, target);
      };
      if (ids in this._teeezCache) return finish(this._teeezCache[ids]);
      fetch(location.pathname + '?option_values=' + encodeURIComponent(ids) + '&section_id=teeez-variant')
        .then((r) => r.text())
        .then((html) => {
          const tag = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-teeez-variant]');
          let found = tag ? JSON.parse(tag.textContent) : null;
          if (found && (!found.options || found.options.join('|') !== values.join('|'))) found = null;
          this._teeezCache[ids] = found;
          finish(found);
        })
        .catch(() => finish(false));
    };
    document.querySelectorAll('product-options-root').forEach((el) => { if (big(el)) clear(el); });
  });
})();

/* Teeez 3.55: bundles with a photo per colour combination (Lust duo).
   Once the shopper picks the shades, the first photo (the gif) becomes a still photo of exactly those shades. */
(() => {
  const start = () => {
    const tag = document.getElementById('teeez-combo-images');
    if (!tag || tag.dataset.ready) return;
    tag.dataset.ready = 'true';
    let map;
    try { map = JSON.parse(tag.textContent); } catch (e) { return; }
    const first = tag.dataset.first;
    const root = tag.closest('.product-page--root') || document;
    const key = () => Array.from(root.querySelectorAll('product-options-root [data-item="radio"]:checked')).map((i) => i.value).join('|');
    const apply = () => {
      const url = map[key()];
      if (!url || !first) return;
      root.querySelectorAll('img').forEach((img) => {
        const s = ['src', 'srcset', 'data-src', 'data-srcset'].map((a) => img.getAttribute(a) || '').join(' ');
        if (img.dataset.teeezCombo || s.indexOf(first) !== -1) {
          img.dataset.teeezCombo = 'true';
          img.removeAttribute('srcset');
          img.removeAttribute('data-srcset');
          img.removeAttribute('sizes');
          img.setAttribute('data-src', url);
          img.src = url;
        }
      });
      root.querySelectorAll('.product-page--carousel .carousel--x-container').forEach((vp) => { vp.scrollLeft = 0; });
    };
    root.addEventListener('change', (e) => {
      if (e.target && e.target.closest && e.target.closest('product-options-root')) setTimeout(apply, 60);
    });
    if (/[?&]variant=/.test(location.search)) { apply(); window.addEventListener('load', () => setTimeout(apply, 300)); }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
